import CaptionElement from "@/app/(site)/_components/GCMolecules/CaptionElement"
import ImageElement from "@/app/(site)/_components/SanityElements/ImageElement"
import { type ImageElementType } from "@/gc-sanity-types"
import { clsx } from "@/src/utils/clsx"

interface ImageGroupProps {
    image: ImageElementType
    className?: string
    isAboveTheFold?: boolean
    sizes?: string
    objectSetting?: string
}

export default function ImageGroup({
    className,
    image,
    isAboveTheFold,
    sizes,
    objectSetting
}: ImageGroupProps) {
    return (
        <figure className={clsx("flex h-full w-full flex-col gap-y-4", className)}>
            <ImageElement
                key={image.image.asset?._ref}
                {...image}
                isAboveTheFold={isAboveTheFold}
                sizes={sizes}
                overrideObjectSetting={objectSetting}
            />
            {image.image.caption && <CaptionElement caption={image.image.caption} />}
        </figure>
    )
}
